import React from 'react';
import styled from 'styled-components';

// The only badge we currently have is LIVE - this could be extended for "CANCELLED", "RESCHEDULED", etc.
export const StyledBadge = styled.div`
  color: red;
  display: flex;
  align-items: center;
  gap: 6px;

  .red-circle {
    background-color: red;
    height: 10px;
    width: 10px;
    border-radius: 50%;
  }

  span {
    font: 700 13px/13px 'Centra No2', sans-serif;
    letter-spacing: 1.52px;
  }
`;

const Badge = () => (
  <StyledBadge className="badge">
    <div className="red-circle" />
    <span>LIVE</span>
  </StyledBadge>
);

export default Badge;
